import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function MaxStrokeCycleRow() {
   return (
      <InputRangeRow
         titleProp={"Max Stroke Cycle"}
         descriptionProp={""}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={1.0}
         maxProp={20.0}
         propertyNameProp={"maxStrokeCycle"}
         errorDialogueProp={"1.0-20.0 only"}
         floatProp={true}
      />
   );
}
